import * as Sentry from '@sentry/react';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { CAMPAIGNS_REQUESTED } from './constants';
import { getPartnerCampaigns } from '../../api/';
import { campaignsSucceeded, campaignsFailed } from './actions';
import { parseClientError } from '../../api/utils';
import { getUserData } from '../auth/selectors';
import { logException } from '../../logger';
import { getPartnerId } from '../Admin/selectors';

// gets called when `CAMPAIGNS_REQUESTED` is dispatched
function* getRequestedCampaigns() {
    try {
        const partnerId = yield select(getPartnerId);
        const params = {
            limit: 50,
            partnerId,
        };

        const campaigns = yield call(getPartnerCampaigns, params);
        yield put(campaignsSucceeded(campaigns));
    } catch (e) {
        Sentry.captureException(e);
        const userData = yield select(getUserData);
        logException(e, { ...userData });
        const error = parseClientError(e);
        const message = error && error.message ? error.message : error;
        yield put(campaignsFailed(message));
    }
}

export default function*() {
    yield all([yield takeLatest(CAMPAIGNS_REQUESTED, getRequestedCampaigns)]);
}
